import { FC } from 'react';

export type Platform = 'AMAZON' | 'ROKU' | 'SAMSUNG' | string;
export type PlatformSize = 'Big' | 'Small';

interface PlatformLogoProps {
    size: PlatformSize;
    platform?: Platform;
}

const PlatformLogo: FC<PlatformLogoProps> = ({ size, platform }) => {
    const getImageSrc = (): string => {
        switch (platform) {
            case 'AMAZON':
                return `/${size}_Amazon.png`;
            case 'ROKU':
                return `/${size}_Roku.png`;
            case 'SAMSUNG':
                return `/${size}_Samsung.png`;
            case 'DV360':
                return `/${size}_DV360.png`;
        }
        return '';
    };

    const src = getImageSrc();
    const width = size === 'Big' ? '50px' : '40px';

    return <img alt={platform} src={src} width={width} />;
};

export type { PlatformLogoProps };
export default PlatformLogo;
